import { useState } from "react";
import { Dropdown, MenuProps } from "antd";
import { ArrowDownOutlined, ArrowRightOutlined } from "@ant-design/icons";

import { Typography } from "@atoms";

import { StoriesItem, CurrentStories } from "./myStoriesList.styles";
import { useNavigate, useParams } from "react-router-dom";
import { useStoriesDataContext } from "contexts/StoriesContext";

// @ts-ignore
const formatStoriesForDropdown = (storiesArray, id, navigate, wholeStory) => {
  // @ts-ignore
  return storiesArray.map((story, index) => ({
    label: (
      <StoriesItem onClick={() => navigate(`/${wholeStory}/${story.uuid}`)} current={story.uuid === id} style={{ margin: 0 }}>
        <Typography as="h3" className="ant-dropdown-menu-title-content">
          {story.name}
        </Typography>
      </StoriesItem>
    ),
    key: String(index + 1), // Генерируем ключи
  }));
};

interface IMyStoriesList {
  name: string,
  wholeStory: string,
}

function MyStoriesList({ name, wholeStory }: IMyStoriesList) {
  const { id } = useParams();
  const navigate = useNavigate();
  const { stories, storiesLoading } = useStoriesDataContext();
  const [open, setOpen] = useState(false)

  const items: MenuProps["items"] = formatStoriesForDropdown(stories, id, navigate, wholeStory);

  return (
    <Dropdown
      overlayClassName="myStoriesListDropdown"
      placement="bottomLeft"
      trigger={["click"]}
      open={open}
      menu={{
        items,
        onClick: (info): void => {
          const keys = ["1"];
          if (!keys.includes(info.key)) setOpen(false);
        },
      }}
    >
      <CurrentStories onClick={() => setOpen((prev) => !prev)}>
        <Typography
          as="h3"
          style={{ color: "#391D0A" }}
        >
          {name}
        </Typography>
        {open ? (
          <ArrowDownOutlined />
        ) : (
          <ArrowRightOutlined />
        )}
      </CurrentStories>
    </Dropdown>
  )
};

export default MyStoriesList;
